module.exports = __webpack_public_path__ + "images/feature/doc-tag-1-fc7255d51a477ff07113eb43cb122831.jpg";